import { sqliteTable, text, real, index, uniqueIndex } from "drizzle-orm/sqlite-core";
import { accounts } from "./accounts";
import { bankAccounts } from "./bank-accounts";

export const CHEQUE_TYPES = ["received", "paid"] as const;
export const CHEQUE_STATUSES = [
  "received",
  "issued",
  "deposited",
  "cleared",
  "bounced",
  "voided",
  "cancelled",
] as const;

// ============================================================================
// cheques — received/paid cheque register with deposit and clearing workflow
// ============================================================================
export const cheques = sqliteTable("accounting_cheques", {
  id: text("id").primaryKey(),
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  chequeType: text("cheque_type", { enum: CHEQUE_TYPES }).notNull(),
  status: text("status", { enum: CHEQUE_STATUSES }).notNull(),
  chequeNo: text("cheque_no").notNull(),
  chequeDate: text("cheque_date").notNull(),
  dueDate: text("due_date"),
  issueDate: text("issue_date"),
  receivedDate: text("received_date"),
  depositDate: text("deposit_date"),
  clearedDate: text("cleared_date"),
  bouncedDate: text("bounced_date"),
  cancelledDate: text("cancelled_date"),
  // Polymorphic payment header id: accounting_payments.id or accounting_receipts.id.
  paymentId: text("payment_id"),
  partyType: text("party_type", { enum: ["customer", "supplier", "employee", "other"] }),
  partyId: text("party_id"),
  bankAccountMasterId: text("bank_account_master_id").references(() => bankAccounts.id),
  clearingAccountId: text("clearing_account_id").references(() => accounts.id),
  counterpartyBankName: text("counterparty_bank_name"),
  counterpartyBankBranch: text("counterparty_bank_branch"),
  counterpartyAccountNo: text("counterparty_account_no"),
  amount: real("amount").notNull(),
  currencyCode: text("currency_code").notNull().default("THB"),
  referenceNo: text("reference_no"),
  glSourceId: text("gl_source_id"),
  notes: text("notes"),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyStatusIdx: index("cheques_company_status_idx").on(table.companyId, table.status, table.chequeDate),
  companyBranchIdx: index("cheques_company_branch_idx").on(table.companyId, table.branchId),
  paymentIdx: index("cheques_payment_idx").on(table.paymentId),
  bankAccountIdx: index("cheques_bank_account_idx").on(table.companyId, table.bankAccountMasterId),
  companyChequeUnique: uniqueIndex("cheques_company_type_no_unique").on(table.companyId, table.chequeType, table.chequeNo),
}));

export type Cheque = typeof cheques.$inferSelect;
export type NewCheque = typeof cheques.$inferInsert;
